export default __webpack_public_path__ + "static/media/AfnFashion1.eb8174f1.jpg";